import React from 'react';
import articlesData from '~/data/sidebar/featured_articles.json';

type ArticlesProps = {
  block: {
    _template: string;
    css_class_name: string;
    [key: string]: any;
  }
  data: { node: FeaturedCategory }[];
};

/**
 * Display a list of articles in a 3 column layout.
 * @param block a block with a list of article cards
 * @returns React component
 */
const Articles: React.FC<ArticlesProps> = ({ block, data }) => {
  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className='container container--articles'>
        {data.map(({node: category}) => {
          if (category.ArticlesCount === 0) return null;
          return (
            <FeaturedCard
              key={category.Id}
              category={category}
              prefix={'academy'}
            >
              <FeaturedArticlesList
                articles={category.Articles}
                shortcode={category.Shortcode}
              />
            </FeaturedCard>
          );
        })}
      </div>
    </section>
  );
};

const FeaturedArticlesList: React.FC<{
  articles: FeaturedArticle[];
  shortcode: string;
}> = ({ articles, shortcode }) => {
  return (
    <ul className='article-card__suggestions'>
      {articles.map((article, index) => (
        <a
          className='article-card__suggestion'
          href={`${shortcode}/${article.UrlPath}`}
          key={`article-card-suggestion-${index}`}
        >
          {article.ListTitle}
        </a>
      ))}
    </ul>
  );
};

/**
 * Visualization of articles block
 * @param category with featured articles
 * @returns React component
 */
const FeaturedCard: React.FC<{
  category: FeaturedCategory;
  children: any;
  prefix: string;
}> = ({ category, children, prefix }) => {
  const articlesCount = `${category.ArticlesCount} article${
    category.ArticlesCount === 1 ? '' : 's'
  }`;
  const featuredData =
    articlesData.featured_categories.find(
      articleData => articleData.category === category.Shortcode
    ) || articlesData.default;

  return (
    <div className='article-card'>
      <img
        src={featuredData.index.image}
        alt={featuredData.index.image_alt_text}
        className='article-card__image'
      />
      <h3 className='article-card__title'>{category.Name}</h3>
      <h5 className='article-card__text'>{articlesCount}</h5>
      {children}
      <a
        className={`cta cta-secondary article-card__cta`}
        href={`${category.Shortcode}/${featuredData.explore_all_url_path}`}
      >
        {category.Title}
      </a>
    </div>
  );
};

export default Articles;
